import { CONFIG_KEYS, getClientConfigValue } from './config'

function googleOptimizeUrl(): string {
  const googleOptimizeContainerId = getClientConfigValue(
    CONFIG_KEYS.NEXT_PUBLIC_GOOGLE_OPTIMIZE_CONTAINER_ID
  )
  return `https://www.googleoptimize.com/optimize.js?id=${googleOptimizeContainerId}`
}

export default googleOptimizeUrl
